import { Component } from "react";
import { connect } from "react-redux";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 3 PRO React components
import MDInput from "components/MDInput";

import {
	SET_TEMPLATE_NAME_EN,
	SET_TEMPLATE_DESCRIPTION_EN,
	SET_TEMPLATE_POST_DESCRIPTION_EN
} from "actions/types";

class Step3 extends Component {
	sendState() {
		return this.state;
	}

	isValidated() {
		return true;
	}

	render() {
		const { dispatch, lang } = this.props;
		return (
			<Grid container spacing={3} justifyContent="center">
				<Grid item xs={12}>
					<MDInput
						label="Nom"
						id="name-en"
						fullWidth
						value={lang?.en?.name || ""}
						onChange={e =>
							dispatch({
								type: SET_TEMPLATE_NAME_EN,
								payload: e.target.value
							})
						}
					/>
				</Grid>
				<Grid item xs={12}>
					<MDInput
						label="Description"
						id="descrption-en"
						fullWidth
						multiline
						rows={5}
						value={lang?.en?.description || ""}
						onChange={e =>
							dispatch({
								type: SET_TEMPLATE_DESCRIPTION_EN,
								payload: e.target.value
							})
						}
					/>
				</Grid>
				<Grid item xs={12}>
					<MDInput
						label="Post photo description"
						id="post-descrption-en"
						fullWidth
						multiline
						rows={3}
						value={lang?.en?.postDescription || ""}
						onChange={e =>
							dispatch({
								type: SET_TEMPLATE_POST_DESCRIPTION_EN,
								payload: e.target.value
							})
						}
					/>
				</Grid>
			</Grid>
		);
	}
}

const mapStateToProps = state => {
	const { lang } = state.templateReducer;

	return {
		lang
	};
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(
	Step3
);
